import React, { useContext, useEffect } from "react";
import { Card, Input, Row, Col, Divider, Select } from "antd";
import mainContext from "../context/MainContext/mainContext";
import formatIndianNumber from "../../../../../utils/formatIndianNumber";
import { isGujaratBilling } from "../../../../../utils/billingGstUtils";
const { Option } = Select;
const DropdownComponent = ({
  subTotal,
  billingData,
  handleFormChange,
  grandTotal,
}) => {
  let { justView } = useContext(mainContext);

  const formatRoundedIndianNumber = (number) => {
    const roundedNumber = Math.round(number || 0);
    return formatIndianNumber(roundedNumber);
  };

  useEffect(() => {
    if (isGujaratBilling(billingData)) {
      if (Number(billingData?.SGST) !== 9) handleFormChange("SGST", 9);
      if (Number(billingData?.CGST) !== 9) handleFormChange("CGST", 9);
      if (Number(billingData?.IGST) !== 0) handleFormChange("IGST", 0);
    } else {
      if (Number(billingData?.IGST) !== 18) handleFormChange("IGST", 18);
      if (Number(billingData?.SGST) !== 0) handleFormChange("SGST", 0);
      if (Number(billingData?.CGST) !== 0) handleFormChange("CGST", 0);
    }
  }, [
    billingData?.gstNumber,
    billingData?.splitGSTNumber,
    billingData?.state,
    billingData?.splitState,
  ]);

  // Dropdown content
  return (
    <Card className="grandTotal-card">
      {/* <Row>
        <Col span={12}>Municipal Tax</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Input
            min={0}
            value={billingData?.municipalTax}
            onChange={(e) => handleFormChange("municipalTax", e.target.value)}
            style={{ width: "4rem" }}
            controls={false}
            readOnly={justView}
          />
          &nbsp;%
        </Col>
      </Row>
      <Row>
        <Col span={12}>Others</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Input
            min={0}
            value={billingData?.otherTaxes}
            onChange={(e) => handleFormChange("otherTaxes", e.target.value)}
            style={{ width: "4rem" }}
            controls={false}
            readOnly={justView}
          />
          &nbsp;%
        </Col>
      </Row>

      <Row>
        <Col span={12}>+Round</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          <Input
            min={0}
            value={billingData?.round}
            onChange={(e) => handleFormChange("round", e.target.value)}
            style={{ width: "4rem" }}
            controls={false}
            readOnly={justView}
          />
          &nbsp;%
        </Col>
      </Row> */}

      <Row>
        <Col span={12}>Subtotal</Col>
        <Col span={12} style={{ textAlign: "right", marginBottom: "0.5rem" }}>
          {formatRoundedIndianNumber(subTotal)}
        </Col>
      </Row>
      <Divider />
      {/* <Row>
        <Col span={12}>GST</Col>
        <Col span={12} style={{ textAlign: "right", marginBottom: "0.5rem" }}>
          {formatRoundedIndianNumber((subTotal * billingData?.IGST) / 100)}
        </Col>
      </Row> */}
      <Row>
        <Col span={8}>+IGST</Col>
        <Col span={8}>
          <Select
            // className="custom-select-bdf"
            value={Number(billingData?.IGST)}
            defaultValue={0}
            onChange={(value) => handleFormChange("IGST", value)}
            disabled={justView}
            style={{ width: "4rem" }}
          >
            <Option value={0}>0</Option>
            <Option value={5}>5</Option>
            <Option value={18}>18</Option>
            <Option value={28}>28</Option>
          </Select>
          &nbsp;%
        </Col>
        <Col span={8} style={{ textAlign: "right" }}>
          {formatRoundedIndianNumber((subTotal * billingData?.IGST) / 100)}
        </Col>
      </Row>
      <Row>
        <Col span={8}>+SGST</Col>
        <Col span={8}>
          <Select
            className="custom-select-bdf"
            value={Number(billingData?.SGST)}
            defaultValue={0}
            onChange={(value) => handleFormChange("SGST", value)}
            disabled={justView}
            style={{ width: "4rem" }}
          >
            <Option value={0}>0</Option>
            <Option value={2.5}>2.5</Option>
            <Option value={9}>9</Option>
            <Option value={14}>14</Option>
          </Select>
          &nbsp;%
        </Col>
        <Col span={8} style={{ textAlign: "right" }}>
          {formatRoundedIndianNumber((subTotal * billingData?.SGST) / 100)}
        </Col>
      </Row>
      <Row>
        <Col span={8}>+CGST</Col>
        <Col span={8}>
          <Select
            className="custom-select-bdf"
            value={Number(billingData?.CGST)}
            defaultValue={0}
            onChange={(value) => handleFormChange("CGST", value)}
            disabled={justView}
            style={{ width: "4rem" }}
          >
            <Option value={0}>0</Option>
            <Option value={2.5}>2.5</Option>
            <Option value={9}>9</Option>
            <Option value={14}>14</Option>
          </Select>
          &nbsp;%
        </Col>
        <Col span={8} style={{ textAlign: "right" }}>
          {formatRoundedIndianNumber((subTotal * billingData?.CGST) / 100)}
        </Col>
      </Row>

      {/* <Divider />

      <Row>
        <Col span={12}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span className="agencyComm-span">(+/-) Agency Comm</span>
            <Input
              min={0}
              value={billingData?.agencyCommission}
              onChange={(e) =>
                handleFormChange("agencyCommission", e.target.value)
              }
              style={{ marginLeft: "1.3rem" }}
              controls={false}
            />
            &nbsp;%
          </div>
        </Col>

        <Col span={12} style={{ textAlign: "right" }}>
          {formatRoundedIndianNumber(
            (subTotal * billingData?.agencyCommission) / 100
          )}
        </Col>
      </Row> */}

      <Divider />
      <Row style={{ marginTop: "10px", fontWeight: "bold" }}>
        <Col span={12}>Grand Total</Col>
        <Col span={12} style={{ textAlign: "right" }}>
          {formatRoundedIndianNumber(grandTotal)}
        </Col>
      </Row>
    </Card>
  );

  // return (
  //   <Dropdown
  //     overlay={dropdownContent}
  //     trigger={["click"]}
  //     open={visible}
  //     onVisibleChange={handleVisibleChange}
  //   >
  //     <Button style={{ fontWeight: "bold", width: "310px" }}>
  //       Grand Total:
  //       <span style={{ marginLeft: "4rem" }}>
  //         {grandTotal.toFixed(2)} <IoIosArrowUp style={{ marginLeft: "1rem" }} />
  //       </span>
  //     </Button>
  //   </Dropdown>
  // );
};

export default DropdownComponent;
